import React, { PureComponent } from 'react';
import ModalWrapper, { withOnClose } from '../ModalWrapper';
import Translator from '../../../requests/apa/Translator';
import Asset from '../../../requests/apa/Asset';
import Device from '../../../devices/device';
import Utils, { setInitialFocus } from '../../../utils/Utils';
import store from '../../../store';
import { HIDE_MODAL, showModal, AAF_MODAL_PROMOCION_ACTIVA_HBO_MAX, AAF_MODAL_ACTIVA_HBO_MAX_QR } from '../../../actions/modal';
import { Button } from '../../../packages/components/lib/Button';
import './styles/_AAFModalInicialActivaHBOMax.scss';
import { QR_ACTIVATION_CONFIG_HBO_DEFAULT } from '../../RibbonNew/constants';
import { showModalActivaHBOMaxQR } from '../../../components/CardNew/utils.js';
import { sendMetricSelectContentHBO } from '../../../components/CardNew/utils.js';

class AAFModalInicialActivaHBOMax extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isClosing: false
		};

		this.keys = Device.getDevice().getKeys();
		this.hboMaxLogo = Asset.get('activahbomax_modal1_logohbomax') || '';

		this.title = Utils.cutPlayerString(
			Translator.get('activahbomax_modal1_texto_titulo'),
			84
		);

		this.activateButtonText = Utils.cutPlayerString(
			Translator.get('activahbomax_modal1_boton_texto_activalo'),
			22
		);
		this.laterButtonText = Utils.cutPlayerString(
			Translator.get('activahbomax_modal1_boton_texto_despues'),
			22
		);

		this.handleActivate = this.handleActivate.bind(this);
		this.handleLater = this.handleLater.bind(this);
		this.qrActivationConfigHBO = Utils.getRegionaliazedMetadata('qr_activation_config', QR_ACTIVATION_CONFIG_HBO_DEFAULT);
	}

	componentDidMount() {
		setTimeout(() => {
			const primaryButton = document.querySelector('#hbomax-activate-button');
			if (primaryButton && primaryButton.id) {
				setInitialFocus(`#${primaryButton.id}`, false);
			}
		}, 300);
	}

	async handleActivate(e) {
		e.preventDefault();
		e.stopPropagation();

		sendMetricSelectContentHBO(this.props.data, this.title, this.activateButtonText);
		// Cerrar modal actual y abrir modal QR HBO Max
		this.closeModal();
		
		showModalActivaHBOMaxQR(this.qrActivationConfigHBO);
	}

	handleLater(e) {
		e.preventDefault();
		e.stopPropagation();

		sendMetricSelectContentHBO(this.props.data, this.title, this.laterButtonText);
		// Iniciar animación de cierre
		this.setState({ isClosing: true });

		// Esperar a la mitad del tiempo de la animación de salida (0.3s) para empezar a abrir la nueva modal
		setTimeout(() => {
			// Abrir la modal de promoción para que su animación de entrada coincida
			const dispatcher = (this.props && this.props.dispatch) || (store && store.dispatch);
			if (dispatcher && typeof dispatcher === 'function') {
				const modal = {
					modalType: AAF_MODAL_PROMOCION_ACTIVA_HBO_MAX,
					modalProps: {
						data: this.props.data
					}
				};
				dispatcher(showModal(modal));
			}
		}, 300);
	}

	closeModal() {
		const dispatcher = (this.props && this.props.dispatch) || (store && store.dispatch);
		if (dispatcher && typeof dispatcher === 'function') {
			dispatcher({ type: HIDE_MODAL });
		}
	}

	render() {
		const contentClassName = this.state.isClosing 
			? 'hbomax-modal-content closing' 
			: 'hbomax-modal-content';

		return (
			<ModalWrapper classNameComponent="aaf-modal-inicial-activa-hbomax-overlay">
				<div className={contentClassName}>
					<div className="hbomax-logo-container">
						{this.hboMaxLogo && (
							<img 
								src={this.hboMaxLogo} 
								alt="HBO Max" 
								className="hbomax-logo"
							/>
						)}
					</div>

					<div className="hbomax-text-container">
						<h1 className="hbomax-title">{this.title}</h1>
					</div>

					<div className="hbomax-buttons-container">
						<Button
							id="hbomax-activate-button"
							type="button"
							variant={null}
							className="hbomax-button hbomax-button-primary focusable"
							onClick={this.handleActivate}
						>
							{this.activateButtonText}
						</Button>

						<Button
							type="button"
							variant={null}
							className="hbomax-button hbomax-button-secondary focusable"
							onClick={this.handleLater}
						>
							{this.laterButtonText}
						</Button>
					</div>
					</div>

			</ModalWrapper>
		);
	}
}

export default withOnClose(AAFModalInicialActivaHBOMax);



// WEBPACK FOOTER //
// ./src/components/Modal/ActivaHBOMaxQR/AAFModalInicialActivaHBOMax.jsx